module.exports = __webpack_public_path__ + "static/avatar-f8ff1f83b143973f961655e460b362ba.jpg";